import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=80f08fa2&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"
import style0 from "./navigation.vue?vue&type=style&index=0&id=80f08fa2&prod&lang=scss&scoped=true"
import style1 from "./navigation.vue?vue&type=style&index=1&id=80f08fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f08fa2",
  null
  
)

export default component.exports